var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollbackFullAgentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,7.9V2.6c0-0.5-0.6-0.8-1.1-0.5l-10.3,8.5c-0.4,0.3-0.4,0.9,0,1.2l10.3,8.4c0.4,0.4,1.1,0,1.1-0.4v-5.4 c8,0,14.6,6.5,14.6,14.6S34,43.5,26,43.5c-8,0-14.6-6.5-14.6-14.6c0-2.3,0.5-4.5,1.5-6.5c0,0,0-0.1,0.1-0.2 c0.2-0.4,0.4-0.9,0.6-1.2c0.3-0.5,0.6-1.3,0-1.8c-0.6-0.5-3.1-2.6-3.3-2.7c-0.2-0.1-0.9-0.8-1.6,0.2c-0.4,0.6-0.9,1.5-1.3,2.2 c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.3-0.3,0.6-0.4,0.7l0,0c-1.3,2.7-2,5.8-2,9.1c0,11.6,9.4,21,21,21s21-9.4,21-21S37.6,7.9,26,7.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollbackFullAgentIcon);
export default __webpack_public_path__ + "static/media/rollback-full-agent-icon.c81fa3a72ef18a418be114ac486b4502.svg";
export { ForwardRef as ReactComponent };